import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import MiniModal from 'components/MiniModal'

const SmallConversionModal = ({ triggerText, modalContent, sticky, placement, size, customClass }) => {
  // Handles closing <Modal> if clicked outside
  const modalTrigger = useRef(null)
  const [popupOpen, setPopupOpen] = useState(false)

  const closeOpenModals = e => {
    if (modalTrigger.current && popupOpen && !modalTrigger.current.contains(e.target)) {
      setPopupOpen(false)
    }
  }

  useEffect(() => {
    window.addEventListener('mousedown', closeOpenModals)
  })

  return (
    <div ref={modalTrigger}>
      <MiniModal
        open={popupOpen}
        sticky={sticky}
        placement={placement}
        size={size}
        trigger={triggerText}
        className={customClass}
        onToggle={() => {
          setPopupOpen(!popupOpen)
        }}>
        {modalContent}
      </MiniModal>
    </div>
  )
}

SmallConversionModal.propTypes = {
  triggerText: PropTypes.object,
  modalContent: PropTypes.object,
  sticky: PropTypes.bool,
  placement: PropTypes.string,
  size: PropTypes.string,
  customClass: PropTypes.string,
}

export default SmallConversionModal
